/**
 * @description External file when It control the response to all request.
 * @event interceptors we intercepted all responses and if the response code is 401:
 */
import axios from 'axios'
/**
 * @description Create interceptor reference for current app
 * @param axiosRef is the axios instance from the current app (pf. news, go or bestof)
 */
const setup = axiosRef =>
  axiosRef.interceptors.response.use(
    null,
    error => resolveError(error)
  )
/**
 * @description Create interceptor reference for toolbar calls.
 */
const setupLocal = () =>
  axios.interceptors.response.use(
    null,
    error => resolveError(error)
  )
/**
 * @description funcionality for get a new token
 * @param error is the error returned from interceptor (setup or setupLocal fn)
 */
const resolveError = (error) => {
  if (!(error && error.response)) return
  if (error.response.data.path && error.response.data.path.includes('/notify')) {
    return Promise.reject(error)
  }
  if (error.response.status === 401) {
    location.reload()
  } else {
    return Promise.reject(error)
  }
}
export default {
  setup,
  setupLocal
}
